import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-foreground-900 text-background-50">
      <div className="w-full px-4 md:px-6 py-12 md:py-16">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
            <div className="lg:col-span-1">
              <div className="flex items-center gap-2.5 mb-4">
                <div className="w-9 h-9 rounded-lg bg-primary-500 flex items-center justify-center">
                  <i className="ri-vip-crown-line text-lg text-background-50"></i>
                </div>
                <span className="text-lg font-bold font-heading tracking-wide">
                  开云棋牌
                </span>
              </div>
              <p className="text-foreground-300 text-sm leading-relaxed">
                正版棋牌游戏平台，集斗地主、麻将、德州扑克等经典游戏于一体。
                安全稳定、公平公正，5000万+玩家的共同选择。
              </p>
            </div>

            <div>
              <h4 className="text-sm font-semibold mb-4 text-background-50">快速导航</h4>
              <ul className="space-y-2.5">
                <li>
                  <Link to="/" className="text-foreground-300 hover:text-background-50 text-sm transition-colors">
                    首页
                  </Link>
                </li>
                <li>
                  <Link to="/categories" className="text-foreground-300 hover:text-background-50 text-sm transition-colors">
                    游戏分类
                  </Link>
                </li>
                <li>
                  <Link to="/articles" className="text-foreground-300 hover:text-background-50 text-sm transition-colors">
                    游戏资讯
                  </Link>
                </li>
                <li>
                  <Link to="/about" className="text-foreground-300 hover:text-background-50 text-sm transition-colors">
                    关于我们
                  </Link>
                </li>
              </ul>
            </div>

            <div>
              <h4 className="text-sm font-semibold mb-4 text-background-50">热门游戏</h4>
              <ul className="space-y-2.5">
                <li>
                  <Link to="/categories" className="text-foreground-300 hover:text-background-50 text-sm transition-colors">
                    斗地主
                  </Link>
                </li>
                <li>
                  <Link to="/categories" className="text-foreground-300 hover:text-background-50 text-sm transition-colors">
                    麻将
                  </Link>
                </li>
                <li>
                  <Link to="/categories" className="text-foreground-300 hover:text-background-50 text-sm transition-colors">
                    德州扑克
                  </Link>
                </li>
                <li>
                  <Link to="/categories" className="text-foreground-300 hover:text-background-50 text-sm transition-colors">
                    百家乐
                  </Link>
                </li>
              </ul>
            </div>

            <div>
              <h4 className="text-sm font-semibold mb-4 text-background-50">联系我们</h4>
              <ul className="space-y-2.5">
                <li className="flex items-center gap-2 text-foreground-300 text-sm">
                  <i className="ri-phone-line text-base"></i>
                  <span>400-888-8888</span>
                </li>
                <li className="flex items-center gap-2 text-foreground-300 text-sm">
                  <i className="ri-mail-line text-base"></i>
                  <span>service@kaiyunqipai.com</span>
                </li>
                <li className="flex items-center gap-2 text-foreground-300 text-sm">
                  <i className="ri-map-pin-line text-base"></i>
                  <span>中国·北京</span>
                </li>
              </ul>
            </div>
          </div>

          <div className="mt-10 md:mt-12 pt-6 md:pt-8 border-t border-foreground-700/30 flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-foreground-400 text-xs md:text-sm">
              &copy; 2026 开云棋牌 版权所有 | 经营许可证编号：京ICP备XXXXXXXX号
            </p>
            <div className="flex items-center gap-4">
              <a href="#" className="text-foreground-400 hover:text-background-50 text-xs transition-colors" rel="nofollow">
                隐私政策
              </a>
              <a href="#" className="text-foreground-400 hover:text-background-50 text-xs transition-colors" rel="nofollow">
                用户协议
              </a>
              <a href="#" className="text-foreground-400 hover:text-background-50 text-xs transition-colors" rel="nofollow">
                免责声明
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}